import {
	rPost
} from '@/utils/http.js';
// import axios from 'axios';



/**
 * 获取历史订单
 * @returns 
 */
export function getOrder() {
	return rPost('/Orders_list');
}

export function getOrderDetail(id) {
	return rPost('/Order_item', {
		orderId: id
	});
}

export function getUserInfo(data = {}) {
	return rPost('/Get_qr_info', data);
}





// 绑定卡
export function sendCard(id, pin) {
	return rPost('/Send_Card', {
		id,
		pin
	});
}



// 二维码
export function getQr(cardNum) {
	// return axios.post(
	//     process.env.VUE_APP_BASE_API+"/Get_qr",
	//     {
	//         sign: store.getters.getSign
	//     },{
	//         headers:{
	//             'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
	//         } 
	//     }
	// ).then(response=>{
	//     console.log(response);
	//     return 'data:image/png;base64,' + btoa(
	//         new Uint8Array(response.data)
	//           .reduce((data, byte) => data + String.fromCharCode(byte), '')
	//       );
	// });
	return rPost("/Get_qr", {

		cardNum: cardNum

	});

	// return 'data:image/png;base64,' + btoa(
	//     new Uint8Array(response.data)
	//       .reduce((data, byte) => data + String.fromCharCode(byte), '')
	//   );
}




/**
 * 获取优惠券
 * @returns 
 */
export function getCoupon(header) {

	return rPost('/Get_Rewards', {

		header: JSON.stringify(header)
	}, {
		isLoad: true
	});


}


// 查询星礼卡列表
export function GiftList() {
	return rPost('/GetStarCardList');
}



// 购买星礼卡
export function PayCard(info) {
	return rPost('/PayStarCard', {
		info: JSON.stringify(info)
	}, {
		isLoad: true
	});
}


// 查询星礼卡列表
export function GiftList2() {
	return rPost('/GetStarCardList2');
}



// 购买星礼卡
export function PayCard2(info) {
	return rPost('/PayStarCard2', {
		info: JSON.stringify(info)
	}, {
		isLoad: true
	});
}
// 获取调查
export function find_email_questionnaire() {
	return rPost('/find_email_questionnaire');
	
}